// Pure utility functions for the Crafting system — no React dependencies.
import { Material, Recipe } from '../components/Crafting';

export function getItemTypeString(itemType: string | number): string {
  if (typeof itemType === 'string') return itemType;
  const map: Record<number, string> = {
    0: 'weapon', 1: 'armor', 2: 'accessory',
    3: 'consumable', 4: 'material', 5: 'tool'
  };
  return map[itemType] || 'unknown';
}

export function getRarityColor(rarity: string): string {
  switch (rarity.toLowerCase()) {
    case 'common':    return '#9e9e9e';
    case 'uncommon':  return '#4caf50';
    case 'rare':      return '#2196f3';
    case 'epic':      return '#9c27b0';
    case 'legendary': return '#ff9800';
    default:          return '#9e9e9e';
  }
}

export function getRarityIcon(rarity: string): string {
  switch (rarity.toLowerCase()) {
    case 'common':    return '⚪';
    case 'uncommon':  return '🟢';
    case 'rare':      return '🔵';
    case 'epic':      return '🟣';
    case 'legendary': return '🟠';
    default:          return '⚪';
  }
}

export function getRarityBorderColor(rarity: string): string {
  return getRarityColor(rarity);
}

export function getTypeIcon(type: string | number): string {
  switch (getItemTypeString(type).toLowerCase()) {
    case 'weapon':     return '⚔️';
    case 'armor':      return '🛡️';
    case 'accessory':  return '💍';
    case 'consumable': return '🧪';
    case 'material':   return '🔧';
    default:           return '📦';
  }
}

export function getItemTypeFromResult(type: string | number): 'Weapon' | 'Armor' | 'Accessory' {
  switch (getItemTypeString(type).toLowerCase()) {
    case 'weapon':    return 'Weapon';
    case 'armor':     return 'Armor';
    case 'accessory': return 'Accessory';
    default:          return 'Weapon';
  }
}

export function canCraftRecipe(recipe: Recipe, inventory: Material[]): boolean {
  const inventoryMap = new Map(inventory.map(item => [item.materialId, item.quantity]));
  return recipe.ingredients.every(ingredient => {
    const available = inventoryMap.get(ingredient.materialId) || 0;
    return available >= ingredient.quantity;
  });
}
